import { ROUTES } from '../../../constants/routes'

export function registerRoute() {
  return ROUTES.register
}
